import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { onChange_CohortSelectUser } from "../action";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Table from "react-bootstrap/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const CohortUserSelect = (props) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredUsers =
    props.seedData.users &&
    props.seedData.users.filter(
      (user) =>
        (user.name && user.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        user.id.toString().includes(searchTerm) ||
        user.mobile.includes(searchTerm)
    );

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const selectedUsers = props.cohortSelectUser || [];

  const handleCheckboxChange = (event, id) => {
    const newSelectedUsers = event.target.checked
      ? [...selectedUsers, id]
      : selectedUsers.filter((userId) => userId !== id);

    props.handleCohortSelectUserChange(newSelectedUsers);
  };

  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>

        <FormControl component="fieldset">
          <p style={styles.label}>
            Select User <span style={{ color: "red" }}>*</span>
          </p>

          {/* Search Field */}
          <TextField
            fullWidth
            id="search-user"
            label="Search by ID/ Name/ Phone No."
            variant="standard"
            value={searchTerm}
            onChange={handleSearchChange}
            sx={{
              "& .MuiInput-underline:before": { borderBottomColor: "#14AE78" },
              "& .MuiInput-underline:after": { borderBottomColor: "#14AE78" },
            }}
          />

          {/* Table Container */}
          <TableContainer
            component={Paper}
            style={styles.tableContainer}
          >
            <Table stickyHeader>
              <TableBody>
                {filteredUsers.map((user, index) => (
                  <TableRow
                    key={user.id}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#fff" : "#f0f0f0",
                    }}
                  >
                    <TableCell>
                      <Checkbox
                        checked={selectedUsers.includes(user.id)} 
                        onChange={(e) => handleCheckboxChange(e, user?.id)}
                        style={styles.checkbox}
                      />

                    </TableCell>
                    <TableCell>{user.id}</TableCell>
                    <TableCell>{user.name || "N/A"}</TableCell>
                    <TableCell>{user.mobile}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* Error Message */}
          <div style={{ marginTop: "10px" }}>
            {props.errors?.cohortSelectUser && (
              <p style={styles.errorMessage}>
                {props.errors.cohortSelectUser}
              </p>
            )}
          </div>
        </FormControl>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",  
    height: "100vh",
    backgroundColor: "#FFFFFF",
    margin: "0",
    paddingTop: "20px",  
     borderRadius:"24px"
  },
  contentWrapper: {
    width: "60vw",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop:"-17px"
  },
  label: {
    fontSize: "24px",
    fontWeight: 500,
    textAlign: "left",
    marginBottom: "-2px",  
  },
  tableContainer: {
    width: "46vw",
    height: "60vh",  
    overflowY: "auto",  
    marginTop: "15px",
  },
  checkbox: {
    color: "#14AE78",
  },
  errorMessage: {
    color: "red",
    textAlign: "left",
    fontSize: "14px", 
  },
};

export default CohortUserSelect;
